import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { apiFetch } from "@/lib/api";
import { AuthShell, inputCls, labelCls, primaryBtn } from "@/components/AuthShell";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiFetch("/auth/forgot-password", { method: "POST", body: JSON.stringify({ email: email.trim() }) });
      toast.success("If that email exists, a reset code has been sent");
      navigate("/reset-password", { state: { email: email.trim() } });
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="We'll email you a code to reset it."
      footer={<Link to="/login" className="font-semibold text-price hover:underline">Back to sign in</Link>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className={labelCls}>Email</label>
          <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
        </div>
        <button data-testid="forgot-submit" type="submit" disabled={loading} className={primaryBtn}>
          {loading ? "Sending…" : "Send reset code"}
        </button>
      </form>
    </AuthShell>
  );
}
